export default __webpack_public_path__ + "static/media/010_photo.68937856.jpg";